// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__naK-L","content":"Consent_content__ZcrMf","footer":"Consent_footer__36Wht"};